import styled from "styled-components";

export const SideTabCard = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 40px;
  padding: 40px 60px;
  align-items: center;

  @media (max-width: 764px) {
    display: none;
  }
`;

export const SideTabs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 30%;
`;

export const TabTitle = styled.button`
  background: none;
  border: none;
  text-align: left;
  font-size: 18px;
  cursor: pointer;
  max-width: 320px;
  color: ${({ isActive, theme }) => (isActive ? theme.subtext : theme.text)};
  font-weight: ${({ isActive }) => (isActive ? "bold" : "normal")};
  padding: 10px;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.subtext};
  }

  ${({ isActive }) =>
    isActive &&
    `
    &::after {
      content: ' ➜';
      font-size: 18px;
      margin-left: 6px;
      color: inherit;
    }
    padding-right: 16px;
  `}
`;

export const Slide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

export const CardStack = styled.div`
  background-color: ${({ theme }) => theme.cardTransparent};
  padding: 20px;
  border-radius: 16px;
  min-height: 200px;
  max-width: 900px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  gap: 20px;

  .CardContent {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;

    .DescriptionCard {
      font-size: 24px;
      color: ${({ theme }) => theme.text};
      padding-bottom: 30px;
    }

    .OverlayTitle {
      color: ${({ theme }) => theme.text};
      font-size: 20px;
    }

    .OverlaySubtitle {
      color: ${({ theme }) => theme.text};
      font-size: 14px;
    }
  }

  .ImageWrapper {
    flex: none;
    width: 300px;
    height: auto;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
      transition: color 0.3s ease;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
